export default {
    import_account_label: 'Cuenta',
    import_account_imported_on: 'Importado el',
    import_account_updated_on: 'Actualizado el',
    import_account_contacts: 'Contactos',
    import_account_alerts: 'Alertas',
    import_account_categories: 'Etiquetas',
    import_account_behavior: 'Comportamiento',
    import_account_users: 'Usuarios',
    import_account_drivers: 'Conductores',
    import_account_devices: 'Dispositivos',
    import_account_geofences: 'Geocercas',
    import_account_maintenance: 'Mantenimiento',
    import_account_exceptions: 'Excepciones',
    import_account_title: 'Migraciones',
    import_account_import_account: 'Importar cuenta',
    import_account_external_id: 'Id. externo',
    import_account_speed_override: 'Anulación de velocidad',
    import_account_source: 'Fuente',
    import_account_source_all: 'Todos',
    import_account_Done: 'Terminado',
    import_account_DoneWithErrors: 'Terminado con errores',
    import_account_InProgress: 'En progreso',
    import_account_Pending: 'Pendiente',
    import_account_Failed: 'Fallido',
    import_account_status: 'Estado',
    import_account_internal_account_id: 'Id. de cuenta interna',
    import_account_results: 'Resultados',
    import_account_results_updated_on: 'Última Sincronización el',
    import_account_assets: 'Activos'
};